export const START_TIME = "08:00";
export const END_TIME = "18:00";
export const IS_MIDNIGHT = "00:00";
export const END_TIME_WHEN_OPEN_ALL_DAY = "23:59:59.999";
